/** @jsxImportSource @emotion/react */
import { HazardDetail } from '@app/components/Molecules/MapView/RiskMapView/AddLayersDialog'
import { usePreferences } from '@app/hooks/usePreferences'
import { useRiskLayersState } from '@app/risk-migration/hooks/useRiskLayersState'
import { CombinedHazardDetail, getScenarioByHazardDetail } from '../HazardControls'
import { accordionHeader } from './HazardControls.styles'
export interface HazardControlFormHeaderProps {
  hazardDetails: HazardDetail | CombinedHazardDetail
}

export const HazardControlFormHeader_Legacy = ({ hazardDetails }: HazardControlFormHeaderProps) => {
  const { layers } = useRiskLayersState()
  const mapLayer = getScenarioByHazardDetail(layers, hazardDetails as CombinedHazardDetail)
  const { use_hazard_name } = usePreferences()

  return (
    <span css={accordionHeader}>
      {use_hazard_name.flag
        ? (mapLayer?.hazard_name ?? mapLayer?.display_name ?? hazardDetails.title)
        : mapLayer?.display_name || hazardDetails.title}
      <span>{mapLayer?.scenario_name}</span>
    </span>
  )
}
